import { render, staticRenderFns } from "./OfficesCard.vue?vue&type=template&id=b77ae472&scoped=true&"
import script from "./OfficesCard.vue?vue&type=script&lang=js&"
export * from "./OfficesCard.vue?vue&type=script&lang=js&"
import style0 from "./OfficesCard.vue?vue&type=style&index=0&id=b77ae472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77ae472",
  null
  
)

export default component.exports